/**
 * OC2-3562 — <PrescriptionStudy> (renders one Author-study card)
 *
 * Stateless functional component. No useState, no useEffect.
 */

import RichText from '@/components/RichText'
import { CommonCopyUrlWrapper } from '@/components/ui/copy-to-clipboard/CommonCopyUrlWrapper'
import type { Mapping } from '@/types'
import type { IContentItemsContainer } from '@kontent-ai/delivery-sdk'
import type { PrescriptionStudy as PrescriptionStudyItem } from './types'

export interface PrescriptionStudyProps {
	study: PrescriptionStudyItem
	linkedItems: IContentItemsContainer
	mappings: Mapping[]
}

export default function PrescriptionStudy({
	study,
	linkedItems,
	mappings,
}: PrescriptionStudyProps) {
	const author = study.elements.author.value
	const title = study.elements.title.value
	const headingText = title ? `${author} ${title}` : author
	const studyAnchorId = `ps-${study.system.id}`
	const studyCopyUrl =
		typeof window !== 'undefined'
			? `${window.location.pathname}#${studyAnchorId}`
			: `#${studyAnchorId}`

	return (
		<div
			data-testid="prescription-study"
			data-kontent-item-id={study.system.id}
		>
			{headingText && (
				<CommonCopyUrlWrapper
					url={studyCopyUrl}
					className="nsw-h4"
					id={studyAnchorId}
					data-kontent-element-codename="author"
				>
					{headingText}
				</CommonCopyUrlWrapper>
			)}
			<div className="mt-2">
				<RichText
					richTextElement={study.elements.content}
					linkedItems={linkedItems}
					mappings={mappings}
				/>
			</div>
		</div>
	)
}
